import { render, staticRenderFns } from "./user-crud.vue?vue&type=template&id=06f75ae3&"
import script from "./user-crud.js?vue&type=script&lang=js&"
export * from "./user-crud.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports